<template>
  <tr
      :class="[   item.submitted ? 'submitted' : '' ]"
      @click="setWorker(index)"
  >
    <td class="name_col"
        v-if="item.payment_reference_type === 'W'"
        @click="setWorker(index)"
    >
      {{ item.first_name }} {{ item.surname }} - {{ item.job_title }}
      <!--<router-link :to="{name: 'worker_profile', query:{worker_id: item.worker_id}}">-->
      <!--  (x)-->
      <!--</router-link>-->
    </td>
    <td class="name_col"
        v-else
        @click="setWorker(index)"
    >
      {{item.company_trading_name}} - {{ item.first_name }} {{ item.surname }}
    </td>

    <td class="rate_col">
      <!--<router-link :to="{name: 'worker_profile', query:{worker_id: item.worker_id}}">-->
        ({{item.payment_reference_type}}) {{ item.payment_reference }}
      <!--</router-link>-->
    </td>

    <td class="rate_col">
      <Rate :data="item.rate"/>
    </td>

    <template v-if="item && item.payments && item.geo && !isGeoAllZero(item.geo)">
      <td class="geo_col">
        <button
            :disabled="item.submitted"
            class="geo_button"
            type="button"
            @click="setWorker(index)"
        >
          Geo
        </button>
      </td>
    </template>
    <td v-else class="geo_col">-</td>

    <td :class="'status_col ' + item.status_name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '')">{{item.status_name}}</td>

    <td
        v-for="(payItem, payIndex) in item.payments"
        class="day_col"
    >
      <payday_input_horizontal
          v-model="item.payments[payIndex]"
          :disabled="true"
          :rowIndex="payIndex"
          :timesheetId="item.id"
          @click="() => setWorker(index)"
          @validate="() => validateRow(payIndex)"
      />
    </td>

    <td class="checkbox_col">
      <checkbox_input
          v-model="item.back_next_week"
          :disabled="true"
          :hideTextValue="true"
          class="switch"
          name=""
      />
    </td>

    <td class="checkbox_col">
      <checkbox_input
          v-model="item.retention_released"
          :disabled="true"
          :hideTextValue="true"
          class="switch"
          name=""
      />
    </td>

    <template v-if="item && item.payments">
      <td class="total_col">
        <template v-if="!isForeman()">{{ item.totalPriceForHours | currency }}</template><template v-else>-</template>
      </td>
      <td class="total_col">
        <template v-if="!isForeman()">{{ item.totalAdditionsDeductions | currency }}</template><template v-else>-</template>
      </td>
      <td class="total_col">
        <template v-if="!isForeman()">{{ item.totalPriceForHours + item.totalAdditionsDeductions | currency }}</template><template v-else>-</template>
      </td>
    </template>

    <td class="button_col">
      <template>
        <div v-if="item && item.submitted" class="row_status">
          <router-link
              :to="{ name: 'c_timesheet_edit_worker', params: { company_id, start_date, end_date, order_job_id: item.order_job_id, timesheet_id: item.timesheet_id } }"
          >
            <button
                class="timesheet_button"
            >
              <span>View</span>
            </button>
          </router-link>
        </div>
      </template>
    </td>
  </tr>
</template>

<style scoped>
@import '../../components/shared/css/workers-table.css';
</style>

<script>

import checkbox_input from "../../components/timesheet_edit_timesheet/toggle_checkbox.vue";
import PaydayInputHorizontal from "../../components/timesheet_edit_timesheet/payday_input_horizontal.vue";
import Rate from "../../components/shared/Rate.vue";
import {isForeman, isGeoAllZero} from "pages/sunset/timesheets/components/shared";

export default {
  components: {
    checkbox_input,
    payday_input_horizontal: PaydayInputHorizontal,
    Rate
  },
  props: {
    company_id: {required: true},
    start_date: {required: true},
    end_date: {required: true},
    loading: {required: true, type: Boolean},
    saving: {required: true, type: Boolean},
    applyGeoToPayments: {required: true, type: Function},
    item: {required: true, type: Object},
    setWorker: {required: true, type: Function},
    index: {required: true, type: Number},
  },
  methods:{
    isForeman,
    isGeoAllZero
  }
}
</script>